<template>
  <div class="doll-root" :class="{ mini: mini, ongoing: scanOngoing }">
    <fill-button
      v-if="showBubbles"
      v-show="!showClenchHint"
      class="fill-btn relative"
      is-left
      :action="bubbleActions[0]"
      :hit="isLeftHit"
      :mini="mini"
      :breathing="leftBreathing"
      @click="$emit('left-click')"
      @active="$emit('left-active')"
    />
    <fill-button
      v-if="showBubbles"
      v-show="!showClenchHint"
      class="fill-btn relative"
      :action="bubbleActions[1]"
      :hit="isRightHit"
      :mini="mini"
      :breathing="rightBreathing"
      @click="$emit('right-click')"
      @active="$emit('right-active')"
    />
    <!--
      Sanne: the Figma Model-Female split into a torso and two arms (cut at
      the armpit), the arms turning on the same leftArmStyles / rightArmStyles
      as the default doll so they follow the detected arm height.
    -->
    <template v-if="isSanne">
      <img :src="sanneArmLeft" class="sanne-model sanne-arm left absolute" :style="leftArmStyles" />
      <img
        :src="sanneArmRight"
        class="sanne-model sanne-arm right absolute"
        :style="rightArmStyles"
      />
      <img :src="sanneTorso" class="sanne-model absolute" />
    </template>
    <template v-else>
      <img
        v-if="pose === 'default'"
        class="arm left-arm absolute"
        :style="leftArmStyles"
        src="../../assets/Doll/left-arm.svg"
      />
      <img
        v-else-if="pose === 'elbow'"
        class="elbow left-arm-elbow absolute"
        :style="leftArmStyles"
        src="../../assets/Doll/left-front-arm.svg"
      />
      <img
        v-if="pose === 'default'"
        class="arm right-arm absolute"
        :style="rightArmStyles"
        src="../../assets/Doll/right-arm.svg"
      />
      <img
        v-else-if="pose === 'elbow'"
        class="elbow right-arm-elbow absolute"
        :style="rightArmStyles"
        src="../../assets/Doll/right-front-arm.svg"
      />
      <img v-if="pose === 'default'" src="../../assets/Doll/doll.svg" class="absolute" />
      <img
        v-else-if="pose === 'elbow'"
        src="../../assets/Doll/doll-elbow.svg"
        class="absolute"
        style="scale: 1.18;"
      />
    </template>
    <clench v-if="showClenchHint" @ended="onClenchEnded" />
  </div>
</template>

<script>
import doll from '@/mixins/doll';
import brandMode from '@/mixins/brand-mode';
import sanneTorso from '@/assets/sanne/body-model-torso.svg';
import sanneArmLeft from '@/assets/sanne/body-model-arm-left.svg';
import sanneArmRight from '@/assets/sanne/body-model-arm-right.svg';

import Clench from '@/components/Animations/Clench.vue';
import FillButton from './FillButton.vue';

export default {
  name: 'Doll',
  components: {
    FillButton,
    Clench,
  },
  mixins: [doll, brandMode],
  props: {
    pose: {
      type: String,
      default: 'default',
      validator: value => ['default', 'elbow'].includes(value),
    },
  },
  data: () => ({
    useClenchAnimation: true,
    sanneTorso,
    sanneArmLeft,
    sanneArmRight,
  }),
  computed: {
    armRotationBase() {
      if (this.pose === 'elbow') return 15;
      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin mini {
  @apply mx-auto;
  transform: scale(0.6);
  min-height: 290px;
  max-height: 290px;
  .arm {
    top: -3%;
  }
  .elbow {
    top: 20.9%;
  }
  .animation {
    top: 9%;
  }
}
%mini {
  @include mini;
}
.doll-root {
  @apply relative flex justify-center items-center my-auto;
  width: 50%;
  max-width: 193px;
  min-width: 193px;
  height: 100%;
  max-height: 505px;
  min-height: 505px;
  &.mini {
    @extend %mini;
  }
  &.ongoing {
    opacity: 0.2;
  }
  @screen xs {
    @include mini;
    .animation {
      top: 21%;
    }
  }
}
.fill-btn {
  margin-top: 30%;
}
// Figma Model-Female: 207 x 554 in the 505-high doll box; the three pieces
// share the full canvas so they line up, each arm turning on its armpit
.sanne-model {
  height: 100%;
  max-width: none;
}
.sanne-arm {
  &.left {
    transform-origin: 21.6% 26%;
  }
  &.right {
    transform-origin: 78.4% 26%;
  }
}
.arm {
  width: 40%;
  top: 19.5%;
}
.left-arm {
  left: -4%;
  transform-origin: 92% 12%;
}
.right-arm {
  right: -6.5%;
  transform-origin: 10% 12%;
}
.elbow {
  width: 15%;
  top: 33.3%;
  z-index: 2;
}
.left-arm-elbow {
  left: -9.2%;
  transform-origin: 46% 2%;
}
.right-arm-elbow {
  right: -9%;
  transform-origin: 46% 2%;
}
</style>
